import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";


 function ReligiousTimesBase() {
  return (
    <div>
      <HeaderSection></HeaderSection>
<p> تقویم و  و اوقات شرعی</p>
    </div>
  )
}
export default ReligiousTimesBase;